// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xQY_7m {
  width: 100%;
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-background, #f9fafc);
  outline: none;
}

.xQY_7m:focus {
  outline: none;
}

.be1CQT {
  background: var(--color-surface, #fff);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  outline: none;
}

.zJ676t {
  font-size: var(--type-title-md-font-size);
  color: var(--text-neutral-dark);
  font-weight: var(--font-weight-regular);
  margin-bottom: 24px;
  text-align: left;
}

.KqVlcJ {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
}

._ltNVS {
  background: #f9fafc;
  height: 74px;
  border-radius: 4px;
  padding: 8px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
}

.vU4UwJ {
  background: var(--chips-surface-pressed, #ffeee5);
}

.cAsNgR {
  margin-right: 12px;
  display: flex;
  align-items: center;
}

.alaAhP {
  flex: 1;
}

.oa5OaZ {
  font-weight: 600;
  font-size: var(--font-size-md);
}

.dKSOH6 {
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
}

.Cngmyw {
  width: 100%;
  height: 48px;
  background: var(--color-primary);
  color: var(--submit-color, #fff);
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  margin-top: 8px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
}

.Cngmyw:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.ZhzSIC {
  width: 100%;
  height: 48px;
  background: transparent;
  color: var(--color-primary, #d64000);
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: var(--font-size-md);
  cursor: pointer;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
  transition: color 0.2s;
}

.ZhzSIC:hover {
  opacity: 0.8;
}

.SBRnw7 {
  margin-right: 12px;
  accent-color: var(--color-primary, #d64000);
  width: 20px;
  height: 20px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-auth/src/pages/TwoFactorSelect/TwoFactorSelect.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,WAAW;EACX,YAAY;AACd","sourcesContent":[".selectRoot {\n  width: 100%;\n  min-height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--color-background, #f9fafc);\n  outline: none;\n}\n\n.selectRoot:focus {\n  outline: none;\n}\n\n.selectCardWrapper {\n  background: var(--color-surface, #fff);\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  outline: none;\n}\n\n.selectFormTitle {\n  font-size: var(--type-title-md-font-size);\n  color: var(--text-neutral-dark);\n  font-weight: var(--font-weight-regular);\n  margin-bottom: 24px;\n  text-align: left;\n}\n\n.advancedSelector {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.advancedSelectorOption {\n  background: #f9fafc;\n  height: 74px;\n  border-radius: 4px;\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  border: none;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.advancedSelectorOptionActive {\n  background: var(--chips-surface-pressed, #ffeee5);\n}\n\n.advancedSelectorIcon {\n  margin-right: 12px;\n  display: flex;\n  align-items: center;\n}\n\n.advancedSelectorContainer {\n  flex: 1;\n}\n\n.advancedSelectorName {\n  font-weight: 600;\n  font-size: var(--font-size-md);\n}\n\n.advancedSelectorDescription {\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n}\n\n.selectButton {\n  width: 100%;\n  height: 48px;\n  background: var(--color-primary);\n  color: var(--submit-color, #fff);\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 16px;\n  cursor: pointer;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);\n}\n\n.selectButton:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.backButton {\n  width: 100%;\n  height: 48px;\n  background: transparent;\n  color: var(--color-primary, #d64000);\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: var(--font-size-md);\n  cursor: pointer;\n  margin-bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: none;\n  transition: color 0.2s;\n}\n\n.backButton:hover {\n  opacity: 0.8;\n}\n\n.radioInput {\n  margin-right: 12px;\n  accent-color: var(--color-primary, #d64000);\n  width: 20px;\n  height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectRoot": `xQY_7m`,
	"selectCardWrapper": `be1CQT`,
	"selectFormTitle": `zJ676t`,
	"advancedSelector": `KqVlcJ`,
	"advancedSelectorOption": `_ltNVS`,
	"advancedSelectorOptionActive": `vU4UwJ`,
	"advancedSelectorIcon": `cAsNgR`,
	"advancedSelectorContainer": `alaAhP`,
	"advancedSelectorName": `oa5OaZ`,
	"advancedSelectorDescription": `dKSOH6`,
	"selectButton": `Cngmyw`,
	"backButton": `ZhzSIC`,
	"radioInput": `SBRnw7`
};
module.exports = ___CSS_LOADER_EXPORT___;
